export const EquipmentType = {
  PC: 'PC', //pc端
  MOBILE: 'Mobile', //移动端
}

// 公共样式
export const CommonStyle = {
  [EquipmentType.PC]: {
    fontSize: '14px',
  },
  [EquipmentType.MOBILE]: {
    fontSize: '36px',
  }
}

// 公共类
export const CommonClass = {
  [EquipmentType.PC]: 'common-pc-box',
  [EquipmentType.MOBILE]: 'common-mobile-box',
}